import React from 'react';
import PropTypes from 'prop-types';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import { bemGenerator } from '@prisjakt/ui-base';
import Card from './card';

import './index.scss';

const styles = bemGenerator('card-list', ['empty', 'no-content']);

const CardList = props => {
  const items = props.items
    .filter(item => !props.exclude.includes(item.id))
    .slice(0, props.limit);
  const content = (
    <div
      className={styles.block.withModifier({
        horizontal: props.styling === 'horizontal',
        vertical: props.styling === 'vertical',
        'top-margin': !!props.title,
      })}
    >
      {items.length > 0 ? (
        items.map(item => <Card {...item} key={item.id} />)
      ) : (
        <div className={`${styles['no-content']}`}>{props.noContent}</div>
      )}
      <div className={`card ${styles.empty}`} key="empty-1" />
      <div className={`card ${styles.empty}`} key="empty-2" />
      <div className={`card ${styles.empty}`} key="empty-3" />
    </div>
  );
  return props.title ? (
    <Panel header={<PanelHeader title={props.title} />}>{content}</Panel>
  ) : (
    content
  );
};

const { string, number, arrayOf, shape, oneOf, oneOfType } = PropTypes;

CardList.propTypes = {
  title: string,
  limit: number,
  styling: oneOf(['horizontal', 'vertical']),
  exclude: arrayOf(oneOfType([string, number])),
  noContent: string,
  items: arrayOf(
    shape({
      id: oneOfType([string, number]),
      imageUrl: string,
      title: string,
      preamble: string,
      pathName: string,
    })
  ).isRequired,
};

CardList.defaultProps = {
  title: undefined,
  limit: 6,
  exclude: [],
  noContent: null,
  styling: 'horizontal',
};

export default CardList;
